import { LAYOUTS, } from '@voltmoney/types';
import { BorderRadiusTokens, CalendarStateToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import { ACTION } from './types';
import { closeModal, closePanModal, confirmPan, Continue, editDetailsAction, fetchExistingPan, goBack, needHelp, toggleCTA, ValidateDob, ValidateForm, ValidatePan, verifyPan } from './actions';
import SharedPropsService from '../../../../SharedPropsService';
import { RegexConfig, } from '../../../../configs/config';
import { Platform } from "react-native";
import sharedPropsService from "../../../../SharedPropsService";
import { getContactUsDetails } from '../../../../configs/utils';
export const template = (height, applicationId, targetRoute, dob, setIsUserLoggedIn, isPanValidated, isFromPhonePe, contactUsDetails, isFromJupiter) => {
    return {
        layout: {
            id: ROUTE.KYC_PAN_VERIFICATION,
            style: {
                isPartnerPlatform: true
            },
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: 'kycPanVerification', type: WIDGET.KYC_PAN_VERIFICATION_PAGE
                },
            ],
        },
        datastore: {
            kycPanVerification: {
                height,
                needHelpAction: {
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_verifyPanScreen_needHelp' }
                },
                goBackAction: {
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    type: ACTION.GO_BACK,
                    payload: { id: 'bt_verifyPanScreen_goBack' }
                },
                panAction: {
                    type: ACTION.VALIDATE_PAN,
                    payload: {},
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                dobAction: {
                    type: ACTION.VALIDATE_DOB,
                    payload: {},
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                continueAction: {
                    type: ACTION.CONTINUE,
                    payload: {
                        applicationId,
                    },
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                confirmPanAction: {
                    type: ACTION.CONFIRM_PAN,
                    payload: {},
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                closePanModal: {
                    type: ACTION.CLOSE_MODAL,
                    payload: {},
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                state: InputStateToken.DEFAULT,
                dobState: CalendarStateToken.DEFAULT,
                caption: { error: "Please enter a valid PAN number" },
                userName: "",
                year: {
                    id: 'tf_verifyPanScreen_enterYear',
                    title: 'Year',
                    value: `${dob.substring(6)}`,
                    placeholder: 'YYYY',
                },
                month: {
                    id: 'tf_verifyPanScreen_enterMonth',
                    title: 'Month',
                    value: `${dob.substring(3, 5)}`,
                    placeholder: 'MM',
                },
                date: {
                    id: 'tf_verifyPanScreen_enterDate',
                    title: 'Date',
                    value: `${dob.substring(0, 2)}`,
                    placeholder: 'DD',
                },
                prefilledPanNumber: '',
                showKycModal: false,
                counter: 0,
                showErrorModal: false,
                errorMessage: '',
                contactUsDetails,
                modalHeight: 0,
                fetchedData: false,
                isFromJupiter: isFromJupiter,
                editDetailsAction: {
                    type: ACTION.EDIT_DETAILS_ACTION,
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    payload: {}
                },
                closeModal: {
                    type: ACTION.CLOSE_PAN_MODAL,
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    payload: {}
                }
            },
            continueStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                widgetItems: [
                    { id: "space16", type: WIDGET.SPACE },
                    { id: "continue", type: WIDGET.BUTTON },
                    Platform.OS === "ios" ? { id: "spaceMD", type: WIDGET.SPACE } : {},
                ]
            },
            DividerStack: {
                size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk
            },
            customHeader: {
                needHelpAction: {
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_verifyPanScreen_needHelp' }
                },
                goBackAction: {
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    type: ACTION.GO_BACK,
                    payload: { id: 'bt_verifyPanScreen_goBack' }
                },
                hideNeedHelp: isFromPhonePe
            },
            title: {
                label: 'Verify your PAN',
                fontSize: FontSizeTokens.XL,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '700',
            },
            subTitle: {
                label: 'PAN is used to get your investment details',
                color: ColorTokens.Grey_Charcoal,
                fontWeight: '400',
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
            },
            input: {
                id: 'tf_verifyPanScreen_enterPan',
                regex: RegexConfig.PAN,
                value: '',
                type: InputTypeToken.DEFAULT,
                state: InputStateToken.DEFAULT,
                charLimit: 10,
                title: 'PAN',
                placeholder: 'Enter PAN',
                keyboardType: KeyboardTypeToken.default,
                isUpperCase: true,
                action: {
                    type: ACTION.VALIDATE_FORM,
                    payload: { value: '', widgetId: 'input' },
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                caption: {
                    success: '',
                    error: 'Please enter a valid PAN number',
                },
            },
            calendarPicker: {
                year: {
                    id: 'tf_verifyPanScreen_enterYear',
                    title: 'Year',
                    value: `${dob.substring(6)}`,
                    placeholder: 'YYYY',
                },
                month: {
                    id: 'tf_verifyPanScreen_enterMonth',
                    title: 'Month',
                    value: `${dob.substring(3, 5)}`,
                    placeholder: 'MM',
                },
                date: {
                    id: 'tf_verifyPanScreen_enterDate',
                    title: 'Date',
                    value: `${dob.substring(0, 2)}`,
                    placeholder: 'DD',
                },
                state: CalendarStateToken.DEFAULT,
                caption: {
                    success: '',
                    error: 'Age should be between 18 and 100',
                },
                action: {
                    type: ACTION.VALIDATE_FORM,
                    payload: {
                        value: '',
                        widgetId: 'calendarPicker',
                    },
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
            },
            space1: { size: SizeTypeTokens.SM },
            space2: { size: SizeTypeTokens.Size32 },
            space5: { size: SizeTypeTokens.XXXL },
            space3: { size: SizeTypeTokens.XXXL },
            space4: { size: SizeTypeTokens.Size32 },
            spaceMD: { size: SizeTypeTokens.MD },
            spaceMD12: { size: SizeTypeTokens.MD },
            space12: { size: SizeTypeTokens.LG },
            space20: { size: SizeTypeTokens.XXL },
            dobTitle: {
                label: 'Date of birth (as per PAN)',
                fontSize: FontSizeTokens.SM,
                fontWeight: "600",
                lineHeight: 20,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter
            },
            declarationStack: {
                type: StackType.row,
                padding: {
                    all: SizeTypeTokens.MD
                },
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1
                },
                bgColor: ColorTokens.Secondary_05,
                alignItems: StackAlignItems.center,
                alignContent: StackAlignContent.center,
                widgetItems: [
                    { id: "declarationIcon", type: WIDGET.ICON },
                    { id: "space1", type: WIDGET.SPACE },
                    { id: "declarationText1", type: WIDGET.TEXT },
                    { id: "declarationText2", type: WIDGET.TEXT },
                    { id: "declarationText3", type: WIDGET.TEXT },
                ]
            },
            declarationIcon: {
                name: IconTokens.Secure,
                size: IconSizeTokens.MD,
                color: ColorTokens.Secondary_100
            },
            declarationText1: {
                label: "We need your PAN to comply with ",
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal,
                fontWeight: "400"
            },
            declarationText2: {
                label: "RBI ",
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal,
                fontWeight: "600"
            },
            declarationText3: {
                label: "regulations",
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal,
                fontWeight: "400"
            },
            space16: {
                size: SizeTypeTokens.XL
            }
        },
    };
};
export const panVerifyMF = {
    onLoad: async ({ asyncStorage, instrumentTrack, network, getHeight }, { applicationId, targetRoute, setIsUserLoggedIn }) => {
        instrumentTrack('ENTER_PAN_PAGE_VIEWED');
        const user = await SharedPropsService.getUser();
        const sharedPropDOB = await SharedPropsService.getUserDob();
        const accountId = user.linkedBorrowerAccounts[0].accountId;
        const contactUsDetails = await getContactUsDetails();
        // ---- RESET state in case of LENDER change ---- //
        await sharedPropsService.setIsFetchedErrorShowOnce(false);
        // ---------------------------------------------- //
        const isPanValdiated = await SharedPropsService.isPanValidated();
        const isFromPhonePe = await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        let dob = '';
        return Promise.resolve(template(getHeight(), applicationId, targetRoute, dob, setIsUserLoggedIn, isPanValdiated, isFromPhonePe, contactUsDetails, isFromJupiter));
    },
    actions: {
        [ACTION.VERIFY_PAN]: verifyPan,
        [ACTION.VALIDATE_FORM]: ValidateForm,
        [ACTION.VALIDATE_PAN]: ValidatePan,
        [ACTION.VALIDATE_DOB]: ValidateDob,
        [ACTION.CONTINUE]: Continue,
        [ACTION.ENABLE_CONTINUE]: toggleCTA,
        [ACTION.DISABLE_CONTINUE]: toggleCTA,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.GO_BACK]: goBack,
        [ACTION.CONFIRM_PAN]: confirmPan,
        [ACTION.CLOSE_MODAL]: closePanModal,
        [ACTION.ON_LOAD]: fetchExistingPan,
        [ACTION.EDIT_DETAILS_ACTION]: editDetailsAction,
        [ACTION.CLOSE_PAN_MODAL]: closeModal,
    },
    action: {
        routeId: ROUTE.KYC_PAN_VERIFICATION,
        type: ACTION.ON_LOAD,
        payload: {}
    },
    clearPrevious: false
};
